import vhCheck from 'vh-check'
import initHeader from '../blocks/header/header'
import initFormCta from '../blocks/form-cta/form-cta'
import initFormProfile from '../blocks/form-profile/form-profile'
import initProfilePage from '../blocks/profile/profile'
import initProfileSellerPage from '../blocks/profile-seller/profile-seller'
import initFormProperty from '../blocks/property-form/property-form'
import initTabs from '../blocks/about/tabs'
import initCategoryTabs from '../blocks/blog-categories/category-tabs'
import initCardBlogMore from '../blocks/card/card-blog-more'
import buyerAgentsForm from '../blocks/buyer-agents-form/form'
import initForgetPassword from '../blocks/forget-password/forget-password'

import { initVhSizes } from './helpers/modals'

vhCheck()

function initGoogleAutocomplete() {
  var inputs = document.querySelectorAll('.js-google-autocomplete')
  var options = {
    componentRestrictions: {
      country: 'au'
    }
  }

  inputs.forEach(input => {
    new google.maps.places.Autocomplete(input, options)
  })
}

$('.js-google-autocomplete').on('change', function(e) {
  $(this).val('')

  $('.pac-container.pac-logo').empty()
})

window.addEventListener('load', () => {
  initHeader()
  initVhSizes()
  initFormCta()
  initFormProfile()
  initTabs()
  initProfilePage()
  initProfileSellerPage()
  initFormProperty()
  initCategoryTabs()
  initCardBlogMore()
  buyerAgentsForm()
  initForgetPassword()

  initGoogleAutocomplete()
})
